import React from "react";
import { Eye, MousePointerClick, Percent, ArrowUpDown } from "lucide-react";

function StatCard({ icon: Icon, label, value, delta, invertDelta }) {
  const deltaColor =
    delta === 0 || delta == null
      ? "text-gray-500"
      : (invertDelta ? delta < 0 : delta > 0)
      ? "text-green-400"
      : "text-red-400";
  const deltaSign = delta > 0 ? "+" : "";

  return (
    <div className="bg-dark-300 border border-dark-50 rounded-xl p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className="p-2 bg-dark-50/50 rounded-lg">
          <Icon size={18} className="text-copper" />
        </div>
        <span className="text-sm text-gray-400">{label}</span>
      </div>
      <div className="text-2xl font-mono font-bold">{value ?? "—"}</div>
      {delta != null && (
        <div className={`text-xs font-medium mt-1 ${deltaColor}`}>
          {deltaSign}
          {(delta * 100).toFixed(1)}% vs prev period
        </div>
      )}
    </div>
  );
}

export default function GSCOverviewCards({ data }) {
  if (!data) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard
        icon={Eye}
        label="Impressions"
        value={data.impressions?.toLocaleString()}
        delta={data.impressions_delta}
      />
      <StatCard
        icon={MousePointerClick}
        label="Clicks"
        value={data.clicks?.toLocaleString()}
        delta={data.clicks_delta}
      />
      <StatCard
        icon={Percent}
        label="CTR"
        value={data.ctr != null ? `${(data.ctr * 100).toFixed(2)}%` : "—"}
        delta={data.ctr_delta}
      />
      <StatCard
        icon={ArrowUpDown}
        label="Avg Position"
        value={data.avg_position?.toFixed(1)}
        delta={data.position_delta != null ? -data.position_delta / (data.avg_position_prev || 1) : null}
        invertDelta
      />
    </div>
  );
}
